import type BodyType from 'owa-service/lib/contract/BodyType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

// Body type strings got from message body
const HTML_BODY_TYPE: BodyType = 'HTML';
const TEXT_BODY_TYPE: BodyType = 'Text';

// Markup type string got from user options
const HTML_MARKUP_TYPE: string = 'Html';

export default function getDefaultBodyType(): BodyType {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (15,27): Object is possibly 'undefined'.
    // @ts-expect-error
    const composeMarkup = getUserConfiguration().UserOptions.ComposeMarkup;
    const bodyType: BodyType = composeMarkup == HTML_MARKUP_TYPE ? 'HTML' : 'Text';
    return bodyType;
}

export { HTML_BODY_TYPE, TEXT_BODY_TYPE };
